






import Vue from "vue";
import { Component } from "vue-property-decorator";
// @ts-ignore
import { AlertTriangleIcon } from "vue-feather-icons";

@Component({
  components: {
    AlertTriangleIcon,
  },
})
export default class InvalidBadge extends Vue {}
